define('home/views/ForumProfileCardRecentView',[
    'underscore',

    'home/views/common/ActivityCardView',
    'home/mixins/asForumProfileCard',

    'home/templates/forumProfileCardRecent',
], function (
    _,

    ActivityCardView,
    asForumProfileCard,

    forumProfileCardRecentTemplate
) {
    'use strict';

    var parent = ActivityCardView;
    var parentProto = parent.prototype;


    var ForumProfileCardRecentView = parent.extend({
        className: 'card card-profile card-profile-forum',
        template: forumProfileCardRecentTemplate,

        serializeData: function () {
            var data = parentProto.serializeData.apply(this, arguments);
            var thread = this.model.thread;

            return _.defaults(data, {
                relativeTime: this.model.getRelativeTimestamp(),
                target: this.model.activities[0].target.toJSON(),
                threadDescriptionHTML: thread.getDefaultDescription(),
            });
        },
    });

    asForumProfileCard.call(ForumProfileCardRecentView.prototype);

    return ForumProfileCardRecentView;
});

